import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["submitButton"]

  submit(event) {
    // Immediately disable the submit button to prevent double-clicks
    this.submitButtonTarget.disabled = true
    this.submitButtonTarget.value = 'Processing...'
    
    // Allow the form to submit normally
    // No preventDefault() - let the form submit proceed
  }
}
